import {
  Box,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from '@mui/material';
import React from 'react';
import CheckIcon from '@mui/icons-material/Check';
import {IQueryFieldOperator} from '../../../../../utils/queryBuilder';
import {t} from 'i18next';

const MenuProps = {
  PaperProps: {
    'role': "region",
    classes: {
      root: 'aur-conditions-menu-props',
    },
  },
  disableScrollLock: true,
};

interface IQueryFieldDropdownProps {
  fieldLabel?: string;
  dateTestId?: string;
  selectedOperator?: string;
  operators: IQueryFieldOperator[];
  handleConditionChange?: (event: SelectChangeEvent) => void;
}

const QueryFieldDropdown: React.FC<IQueryFieldDropdownProps> = ({
  fieldLabel,
  dateTestId,
  selectedOperator,
  operators,
  handleConditionChange,
}) => {
  const selectedValue = operators.find(
    (item) => item.name === selectedOperator
  )?.label;

  return (
    <Box className={'query-field-dropdown'}>
      <Select
        fullWidth
        className={'aur-conditions-dropdown-container'}
        value={selectedValue}
        onChange={handleConditionChange}
        MenuProps={MenuProps}
        placeholder="Select"
        sx={{
          width: '47.5%',
        }}
        inputProps={{
          'data-testid': dateTestId ?? 'query-field-dropdown',
          'aria-label': t('gaTracking.indexSearch.queryFieldDropdown'),
        }}
        renderValue={() => (
          <Typography className="typo-text body3_size ">
            {selectedValue}
          </Typography>
        )}
      >
        {operators.map((operator) => (
          <MenuItem
            key={operator.name}
            value={operator.label}
            aria-label={`${fieldLabel} ${operator.label} ${selectedOperator === operator.label ? t('indexSearchPage.accessibilityLabel.selected') : t('indexSearchPage.accessibilityLabel.notSelected')}`}
          >
            <Box display="flex" justifyContent="space-between" width="100%">
              <Typography aria-hidden="true" className="typo-text body3_size ">
                {operator.label}
              </Typography>
              {selectedOperator === operator.label && (
                <CheckIcon
                  aria-hidden="true"
                  fontSize="small"
                  className="aur-date-check-mark"
                />
              )}
            </Box>
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};

export {QueryFieldDropdown};
